import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth initialization to complete
  if (authStore.isInitializing) {
    const checkAuth = () => {
      if (!authStore.isInitializing) {
        handleRouting()
      } else {
        setTimeout(checkAuth, 50)
      }
    }
    checkAuth()
  } else {
    handleRouting()
  }

  function handleRouting() {
    const isAuthenticated = authStore.isAuthenticated
    const isTeacher = authStore.isTeacher

    // If route doesn't exist, redirect based on auth status
    if (to.matched.length === 0) {
      next(isAuthenticated ? { name: 'Home' } : { name: 'Login' })
      return
    }

    // Public routes are always accessible
    if (to.meta.public) {
      next()
      return
    }

    // Guest-only routes redirect authenticated users to home
    if (to.meta.guestOnly && isAuthenticated) {
      next({ name: 'Home' })
      return
    }

    // Auth-required routes redirect guests to login
    if (to.meta.requiresAuth && !isAuthenticated) {
      next({ name: 'Login' })
      return
    }

    // Teacher-only routes redirect non-teachers to home
    if (to.meta.requiresTeacher && !isTeacher) {
      next({ name: 'Home' })
      return
    }

    next()
  }
})

export default router
